import { useEffect, useMemo } from 'react';

import { FilterAppliedProps, FilterConfig, Filters, useCurrentFilter } from '@components/filters';
import { IconArrowLeft } from '@components/icons/arrow-left';
import { IconBrandADManager } from '@components/icons/brand-ad-manager';

import { FilterActionButtons } from 'features/filters/filter-action-buttons';
import { useStore } from 'models/Provider';
import { IJob } from 'models/types';

import { useADManagerEnabled } from './hooks';

function Applied({ data }: FilterAppliedProps) {
  const { t } = useStore();

  return (
    <Filters.AppliedFilter
      icon={<IconBrandADManager size={24} />}
      category="AD Manager"
      value={t('integrations.admanager.filters.applied.created')}
      comparer={{
        value: data.value === 'created' ? 'is' : 'not_is',
        label: (data.value === 'created' ? t('comparers.is') : t('comparers.not_is')).replace(
          '...',
          ''
        ),
      }}
    />
  );
}

function Menu() {
  const { t } = useStore();
  const { state, actions, hasValue } = useCurrentFilter();
  useEffect(() => {
    if (!state.comparer) {
      actions.selectComparer('is');
    }
  }, [actions, state.comparer]);
  return (
    <Filters.List>
      <Filters.ListItem
        heading
        label={t('integrations.admanager.title')}
        icon={<IconArrowLeft />}
        onClick={actions.unselectCategory}
      />

      <Filters.ListSeparator />
      <Filters.FilterValueMenu
        items={[
          { value: 'created', label: t('integrations.admanager.filters.created') },
          { value: 'notcreated', label: t('integrations.admanager.filters.notcreated') },
        ]}
        isMulti={false}
        onSetValue={actions.selectValue}
        state={state}
      />
      <FilterActionButtons disableApply={!hasValue} />
    </Filters.List>
  );
}

export function useFilterApplicationADManager(job: IJob): FilterConfig | null {
  const { t } = useStore();
  const enabled = useADManagerEnabled(job.id);
  return useMemo(() => {
    if (!enabled) return null;
    return {
      category: 'adManager',
      label: t('integrations.admanager.title'),
      icon: <IconBrandADManager size={24} />,
      AppliedFilter: Applied,
      Menu: Menu,
      toQueryData: (filter) => {
        switch (filter.value) {
          case 'created':
            return { integrations_json__ad_manager__email__is_none: false };
          case 'notcreated':
            return { integrations_json__ad_manager__email__is_none: true };
          default:
            return {};
        }
      },
    };
  }, [enabled, t]);
}
